import { render, staticRenderFns } from "./RoleLog.vue?vue&type=template&id=450bc69a&scoped=true"
import script from "./RoleLog.vue?vue&type=script&lang=js"
export * from "./RoleLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450bc69a",
  null
  
)

export default component.exports